import { LeadAction } from "../../../models/action.model";

export class SetActions {
  static readonly type = '[Set action] Set action';

  constructor(public actions: LeadAction[]) {
  }
}
